var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[{ inline: _vm.inline }, 'text-center']},[_c('v-progress-circular',{attrs:{"size":_vm.size,"color":"primary","indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }